var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._b({attrs:{"color":"primary","icon-right":"fa fa-file-pdf","title":"Download PDF"},on:{"click":_vm.download}},'q-btn',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }